export default __webpack_public_path__ + "static/media/bg.33b42bf9.png";